export enum EventOriginType {
    EVENT = 'EVENT',
    EVENT_DEVICE = 'EVENT_DEVICE',
}
